module.exports = __webpack_public_path__ + "img/Type=EN, Color=White.6553fe7d.svg";